import { render, staticRenderFns } from "./GetPriceList.vue?vue&type=template&id=5b7defbe&"
import script from "./GetPriceList.vue?vue&type=script&lang=js&"
export * from "./GetPriceList.vue?vue&type=script&lang=js&"
import style0 from "./GetPriceList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports